import processEnvPublic from 'unlikely-env/public'

export default function getAlternateUrl(url = '') {
  return `${processEnvPublic('NEXT_PUBLIC_VERCEL_URL')}${url}`
}
